import axios from "axios"
import config from "../environments/generated.config"
import { mountApiUrl, mountHeaders, handleNotAuthenticated } from "./utils"
import { getSession } from "../providers/session"

const {
  base_url,
  basket_flow,
  basket_count,
  basket,
  grade_details,
  parapar_details,
  surfacado_details,
  grade,
  parapar,
  surfacado,
  delete_grade_item,
  delete_grade_variation,
  delete_parapar_item,
} = config.apis.basket

export async function getBasketFlow() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, basket_flow, { client_id })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function getBasketCount() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, basket_count, { client_id })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function getBasket() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, basket, { client_id })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function getGradeDetails(product_id) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, grade_details, { client_id, product_id })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function getParaparDetails(product_id, order_os) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, parapar_details, { client_id, product_id, order_os })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function getSurfacadoDetails(product_id, order_os) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, surfacado_details, { client_id, product_id, order_os })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function deleteGrade() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, grade, { client_id })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}

export async function deleteParapar() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, parapar, { client_id })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}

export async function deleteSurfacado() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, surfacado, { client_id })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}

export async function deleteGradeItem(product_id, payment_type) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, delete_grade_item, { client_id, product_id, payment_type })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}

export async function deleteGradeVariation(product_id, variation_id) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, delete_grade_variation, {
    client_id,
    product_id,
    variation_id,
  })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}

export async function deleteParaparItem(product_id, order_os) {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, delete_parapar_item, { client_id, product_id, order_os })
  return handleNotAuthenticated(() => axios.delete(url, mountHeaders(user_id, token)))
}
